type StatusType = 'pending' | 'completed' | 'cancelled' | 'paid' | 'partial' | 'low' | 'ok';

const statusConfig: Record<StatusType, { label: string; classes: string }> = {
  pending: { label: 'Pending', classes: 'bg-amber-100 text-amber-700' },
  completed: { label: 'Completed', classes: 'bg-emerald-100 text-emerald-700' },
  cancelled: { label: 'Cancelled', classes: 'bg-red-100 text-red-600' },
  paid: { label: 'Paid', classes: 'bg-emerald-100 text-emerald-700' },
  partial: { label: 'Partial', classes: 'bg-blue-100 text-blue-700' },
  low: { label: 'Low Stock', classes: 'bg-red-100 text-red-600' },
  ok: { label: 'In Stock', classes: 'bg-emerald-100 text-emerald-700' },
};

export default function StatusBadge({ status }: { status: string }) {
  const config = statusConfig[status as StatusType] ?? { label: status, classes: 'bg-gray-100 text-gray-600' };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.classes}`}>
      {config.label}
    </span>
  );
}
